import {useMemoize} from "@vueuse/core"
import { load } from '@fingerprintjs/botd'

export const botDetect = useMemoize(async () => {
    if (process.server) {
        return false
    }
    const res = (await load())?.detect()
    return res?.bot || false
})